import React, { useCallback, useMemo } from 'react';
import UI from '../../../ui';
import StateIcon from '../../../ui/icon/StateIcon.component';
import Session from '../../../utils/Session';
import Util from '../../../utils/Util';
import { markUspsCopFlowStarted } from '../../USPSBusiness/uspsCopFlow';

const { WrappedButton, WrappedButtonType } = UI;

export const FinalizeConnection = ({ isUSPSAccountCreated, redirectUri }) => {
	const FINALIZE_STEPS = [
		{
			id: 'grant',
			content:
				'If you already have a USPS Business Account and have set up your EPA, tap the link below to grant permission to access your account.',
		},
		{
			id: 'portal',
			content:
				'Inside the USPS portal, tap "Go to Auctane" to finalize this connection after agreeing to Terms & Conditions.',
		},
		{
			id: 'continue',
			content: 'Then, continue to the final step below.',
		},
	];

	const handleLinkAccountClick = useCallback(() => {
		const sessionData = Session.getData();
		const { settings } = sessionData;
		const locationState = {
			app: Util.getQueryParamByName('state')?.toLowerCase(),
			brand: 'stamps.com',
		};

		const encodedLocationState = encodeURIComponent(
			`${locationState.app}|${locationState.brand}`
		);

		const copUrl = `${settings.UspsCopUrl}?wf=${settings.USPSBusinessWf}&client_id=${settings.USPSClientId}&state=${encodedLocationState}&redirect_uri=${encodeURIComponent(redirectUri)}&platform=Auctane&reauth=true`;

		markUspsCopFlowStarted();
		window.open(copUrl, '_top', 'noopener,noreferrer');
	}, [redirectUri]);

	const sectionClassName = useMemo(
		() =>
			`guidelines-section guidelines-section--${isUSPSAccountCreated ? 'completed' : 'todo'}`,
		[isUSPSAccountCreated]
	);

	return (
		<section className="usps-guidelines">
			<article className={sectionClassName}>
				<header className="guideline-header">
					<StateIcon isCompleted={isUSPSAccountCreated} />
					<h4>Finalize Your Connection</h4>
				</header>

				<p className="guideline-subtitle">
					Grant Auctane&apos;s Access to Your USPS Business Account
				</p>

				<ol className="guideline-steps">
					{FINALIZE_STEPS.map(step => (
						<li key={step.id}>{step.content}</li>
					))}
				</ol>

				<footer className="guideline-action">
					<WrappedButton
						buttonType={
							isUSPSAccountCreated
								? WrappedButtonType.Secondary
								: WrappedButtonType.Primary
						}
						label={
							isUSPSAccountCreated
								? 'Manage USPS business account'
								: 'Link Your Business Account'
						}
						dataqa={
							isUSPSAccountCreated
								? 'manage-usps-business-account-button'
								: 'finalize-link-business-account-button'
						}
						onClick={handleLinkAccountClick}
						aria-label={
							isUSPSAccountCreated
								? 'Manage USPS business account'
								: 'Link Your Business Account'
						}
					/>
				</footer>
			</article>
		</section>
	);
};
